// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3a1IO","dragIcon":"SortableItem_dragIcon__14CLW","disabled":"SortableItem_disabled__85iee"};